import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, signal, DOCUMENT } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { MetaService } from '../meta.service';
import { app, backend, firebase_options, web } from '../../environments/environment';
import { MatButtonModule } from '@angular/material/button';

interface IBuilder {
  name?: string;
  path?: string;
  id?: string;
  url?: string;
  store?: boolean;
  
  sub?: boolean;

  //Google Analytics
  utm_medium?: string;
  utm_source?: string;
  utm_campaign?: string;
  gclid?: string;//Google Click Id

  //Itunes Connect Analytics
  at?: string;//Affiliate Token
  ct?: string;//Campaign token
  mt?: number;//Media Type
  /* MT
  1   Music
  2   Podcasts
  3   Audiobooks
  4   TV Shows
  5   Music Videos
  6   Movies
  7   iPod Games
  8   Mobile Software Applications
  9   Ringtones
  10  iTunes U
  11  E-Books
  12  Desktop Apps
  */
  pt?: string;//Provider Token

  //Social Meta Tags
  st?: string;//Social Title
  sd?: string;//Social Description
  si?: string;//Social Image

  falling?: boolean;//Whether we are in fallback state
  pregenerated?: boolean;//Whether the firebase link was already generated
}

@Component({
  selector: 'cloudigo-builder',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './builder.component.html',
  styleUrl: './builder.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.no-footer]': 'true'
  }
})
export default class BuilderComponent {
  http = inject(HttpClient);
  meta = inject(MetaService);
  activated = inject(ActivatedRoute);
  document = inject(DOCUMENT);

  fallback = signal<string|null>(null);

  constructor(){
    const name = this.activated.snapshot.params.name;

    if(name){
      const params = Object.entries(this.activated.snapshot.queryParams).map(([key,value]) => {
        if(['redirect','user','token','is_yearly','from_app', 'debug'].includes(key)) return '';
        return `&${key}=${value}`;
      }).join('');

      this.http.get<IBuilder>(`${backend}builder?name=${name}${params}`).pipe(
        takeUntilDestroyed(),
      ).subscribe({
        next: builder => {
          if(!builder.name){
            builder.name = name?.toLowerCase();
          }
          this.handleMeta(builder);
          this.handleBuilder(builder);
        },
        error: error => {
          this.meta.router.navigate(['/']);
        }
      });
    } else {
      const builder = { ...this.activated.snapshot.queryParams };
      if(builder.store){
        builder.store = builder.store == '1' || builder.store == 'true';
      }
      if(builder.mt){
        builder.mt = Number(builder.mt);
      }
      this.handleBuilder(builder);
    }
  }

  UTMasQueryString(builder: IBuilder){
    return Object.entries(builder).map(([key,value]) => {
      if(key.startsWith('utm_')){
        return `${key}=${value}`;
      } else {
        return '';
      }
    }).filter(v => !!v).join('&');
  }

  handleMeta(builder: IBuilder){
    if(builder.st){
      const fallbackDescription = this.meta.meta.getTag('name=description')?.content ?? 'Save with cloudigo';
      this.meta.setTags(builder.st, fallbackDescription, builder.si);
    } else {
      this.meta.setTags();
    }
  }

  handleBuilder(builder: IBuilder){
    if(!this.meta.isBrowser) return;

    let fallback = `${web}`;

    const utmQueryParams = this.UTMasQueryString(builder);

    // if(builder.path && this.meta.isMobile && this.meta.platform.IOS && !builder.falling){
    //   const path = `/${decodeURIComponent(builder.path)}`.replace('//', '/');
    //   let id = decodeURIComponent(builder.id || '');
    //   const dynamicUtmQueryParams = utmQueryParams + (utmQueryParams?'&' : '?') + 'falling=true';
  
    //   if(id){
    //     //When app is opening a web url either inapp browser or externally
    //     if(['/web', '/url'].includes(path)){
    //       //ID should be handled as route + query string + fragment
  
    //       if(utmQueryParams){
    //         //we have at least 1 UTM, so we need to append them to the ID
    //         const [routeWithQuery, routeFragment = ''] = id.split('#');
    //         const fragment = routeFragment ? `#${routeFragment}` : '';
    //         if(id.includes('?')){
    //           //we already have some query parameters
    //           const [route, query = ''] = routeWithQuery.split('?');
  
    //           const currentQueryParams = new URLSearchParams(query);
    //           const newQueryParams = new URLSearchParams(dynamicUtmQueryParams);
              
    //           newQueryParams.forEach((value, key) => {
    //             currentQueryParams.set(key, value);
    //           });
  
    //           id = encodeURIComponent(`${route}?${currentQueryParams.toString()}#${fragment}`);
  
    //         } else {
    //           //we don't currently have any query parameters, so we can just add
    //           id = encodeURIComponent(`${routeWithQuery}?${dynamicUtmQueryParams}#${fragment}`);
    //         }
    //       }
    //     } else {
    //       id = `${id}&${dynamicUtmQueryParams}`;
    //     }
  
    //     id = `?id=${id}`;
    //   } else {
    //     id = `?${dynamicUtmQueryParams}`;
    //   }
  
    //   let fallback = decodeURIComponent(builder.url || '/');

    //   if(fallback.startsWith('/')){
    //     fallback = `${web}${fallback}`;
    //   }

    //   fallback += `${fallback.includes('?') ? '&' : '?'}${dynamicUtmQueryParams}`;

    //   const dynamicLinkInfo = {
    //     domainUriPrefix: app.dynamic,
    //     link: `${web}${path}${id}`,
    //     androidInfo: {
    //       androidPackageName: app.package,
    //       androidFallbackLink: fallback
    //     },
    //     iosInfo: {
    //       iosBundleId: app.package,
    //       iosAppStoreId: app.id,
    //       iosFallbackLink: fallback
    //     },
    //     desktopInfo: {
    //       desktopFallbackLink: fallback,
    //     },
    //     navigationInfo: {
    //       enableForcedRedirect: false
    //     }
    //   };

    //   const infoQueryParams = {
    //     link: encodeURIComponent(dynamicLinkInfo.link),
    //     //*ANDROID
    //     apn: dynamicLinkInfo.androidInfo.androidPackageName,
    //     ...!builder.store? {
    //       afl: encodeURIComponent(dynamicLinkInfo.androidInfo.androidFallbackLink),
    //     } : {},
    //     //amv: 'Android Minimum Build Version
    //     //*IOS
    //     ibi: dynamicLinkInfo.iosInfo.iosBundleId,
    //     ...!builder.store? {
    //       ifl: encodeURIComponent(dynamicLinkInfo.iosInfo.iosFallbackLink),//iphone
    //       ipfl: encodeURIComponent(dynamicLinkInfo.iosInfo.iosFallbackLink),//ipad
    //     } : {},
    //     // ius: 'App Custom Url Scheme',
    //     ipbi: dynamicLinkInfo.iosInfo.iosBundleId,
    //     isi: dynamicLinkInfo.iosInfo.iosAppStoreId,
    //     //imv: 'iOS Minimum Build Version
    //     // efr: 1,
    //     //*OTHER
    //     ofl: dynamicLinkInfo.desktopInfo.desktopFallbackLink
    //   }

    //   const manualDynamicLink = `${app.dynamic}/?${Object.entries(infoQueryParams).map(([key,value]) => `${key}=${value}`).join('&')}${utmQueryParams}`;
      
    //   this.document.location.href = manualDynamicLink;

    //   return;
      
    // }

    if((builder.store && this.meta.isMobile) || !builder.url){
      if(this.meta.platform.IOS){
        fallback = `https://itunes.apple.com/mt/app/cloudigo/id${app.id}?${utmQueryParams}`;
      } else {
        fallback = `https://play.google.com/store/apps/details?id=${app.package}&${utmQueryParams}`.replace(/&$/, '');
      }
    } else{
      fallback = decodeURIComponent(builder.url);

      if(fallback.startsWith('/')){
        fallback = `${web}${fallback}`;
      }

      fallback += `${fallback.includes('?') ? '&' : '?'}${utmQueryParams}`.replace(/(&|\?)$/, '');
    }

    if(!fallback || this.activated.snapshot.queryParams.debug){
      this.fallback.set(fallback);
    } else {
      this.document.location.href = fallback;
      setTimeout(() => {
        this.fallback.set(fallback);
      }, 4000);
    }
  }

}
